export const enUS = {
  multiFactorAuth: "Multi-Factor Authentication",
  enterOTP: "Enter OTP sent to your mobile or email",
  enterEmailOTP: "Enter OTP sent to your email",
  enterSMSOTP: "Enter OTP sent to your mobile",
  otp: "One-time password (OTP)",
  resendOTPEmail: "Resend OTP via Email",
  resendOTPSMS: "Resend OTP via SMS",
  rememberDevice: "Remember this device",
  submit: "Submit",
  cancel: "Cancel",
  second:"S"
};
